module.exports = __webpack_public_path__ + "static/img/2.4bd3604.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/cpxh/2.jpg
// module id = SZKo
// module chunks = 0